import { commonConstants } from "@/actions/constants/commonConstants";
import { termsAndConditionConstants } from "@/actions/constants/termsAndConditionConstants";
import { termsAndConditionService } from "@/services/termsAndConditionService";
import { call, put } from "redux-saga/effects";

function* getTermsAndCondition(action: any): any {
  try {
    const response = yield call(termsAndConditionService.termsAndCondition, action.payload);
    if (response && response.success) {
      yield put({ type: termsAndConditionConstants.termsAndConditionSuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: termsAndConditionConstants.termsAndConditionFailure, payload: response?.errorMessage ?? response });
      yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage ?? 'Failed to fetch terms and conditions' });
    }
  } catch (error) {
    yield put({ type: termsAndConditionConstants.termsAndConditionFailure, payload: error });
    yield put({type: commonConstants.showErrorMessage, payload:error})
  }
}

function* getTermsOfService(action: any): any {
  try {
    const response = yield call(termsAndConditionService.getByType, 'terms_and_conditions');
    if (response && response.success) {
      yield put({ type: termsAndConditionConstants.termsofServiceSuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: termsAndConditionConstants.termsofServiceFailure, payload: response?.errorMessage ?? response });
      yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage ?? 'Failed to fetch terms of service' });
    }
  } catch (error) {
    yield put({ type: termsAndConditionConstants.termsofServiceFailure, payload: error });
    yield put({ type: commonConstants.showErrorMessage, payload: error });
  }
}

function* getPrivacyPolicy(action: any): any {
  try {
    const response = yield call(termsAndConditionService.getByType, 'privacy_policy');
    if (response && response.success) {
      yield put({ type: termsAndConditionConstants.privacyPolicySuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: termsAndConditionConstants.privacyPolicyFailure, payload: response?.errorMessage ?? response });
      yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage ?? 'Failed to fetch privacy policy' });
    }
  } catch (error) {
    yield put({ type: termsAndConditionConstants.privacyPolicyFailure, payload: error });
    yield put({ type: commonConstants.showErrorMessage, payload: error });
  }
}

export const termsAndConditionSaga = {
    getTermsAndCondition,
    getTermsOfService,
    getPrivacyPolicy,
}
